/*
 * @Author: guoyun 327227584@qq.com
 * @Date: 2023-11-20 09:28:11
 * @LastEditors: guoyun 327227584@qq.com
 * @LastEditTime: 2023-11-27 19:09:45
 */
const Cesium = window.Cesium
//element左上角为初始位置
const FirstEmuns = { top: 0, bottom: 1, center: 0.5 }
const SecondEmuns = { left: 0, right: 1, center: 0.5 }

export default class OverlayTd {
  _el

  _viewer

  _positon

  _offset

  //'bottom-left'，'bottom-center'，'bottom-right'， 'center-left'，'center-center'，'center-right'，'top-left'， 'top-center'，和'top-right'
  _first_ratio

  _second_ratio

  constructor(props_data) {
    const props = props_data || {}
    this._viewer = props.viewer
    this._el = props.element
    this._offset = props.offset || [0, 0]
    this.getPositioning(props.positioning || 'top-left')

    this._viewer.cesiumWidget.container.appendChild(this._el)
    this._el.style.position = 'absolute'


  }

  setPosition(positon) {
    if (positon) {
      this._el.style.display = ''
      this._positon = positon._value ? positon._value : positon//传入模型笛卡尔坐标位置
      this._viewer.scene.postRender.addEventListener(this.postRender.bind(this), this)
    } else {
      this.hide()
    }
  }

  postRender() {
    if (!this._el || !this._el.style) return
    const canvasHeight = this._viewer.scene.canvas.height
    const windowPosition = new Cesium.Cartesian2()
    Cesium.SceneTransforms.wgs84ToWindowCoordinates(this._viewer.scene, this._positon, windowPosition)
    const elHeight = this._el.offsetHeight * this._first_ratio
    this._el.style.bottom = canvasHeight - windowPosition.y - elHeight + this._offset[1] + 'px'
    const elWidth = this._el.offsetWidth * this._second_ratio
    this._el.style.left = windowPosition.x - elWidth + this._offset[0] + 'px'
  }

  hide() {
    this._el.style.display = 'none'
    this._viewer.scene.postRender.removeEventListener(this.postRender, this)
  }

  destroy() {
    if (!this._el) {
      return
    }
    this._el.parentElement.removeChild(this._el)
    this._viewer.scene.postRender.removeEventListener(this.postRender, this)
  }

  getPositioning(positioning) {
    const p = positioning.split('-')
    this._first_ratio = FirstEmuns[p[0]] || FirstEmuns.top
    this._second_ratio = SecondEmuns[p[1]] || SecondEmuns.left
  }
}
